import { useAdminInformationsStore } from "@/store/modules/adminInformations";
import AdminChildren from "@/router/atmo/admin/children";
import ProjectsChildren from "@/router/atmo/projects/children";
import MaterialsChildren from "@/router/atmo/materials/children";

const Projects = () =>
  import(/* webpackChunkName: "Projects" */ "@/components/atmo/Projects.vue");

const Materials = () =>
  import(/* webpackChunkName: "Materials" */ "@/components/atmo/Materials.vue");

const EurofinsCatalog = () =>
  import(
    /* webpackChunkName: "EurofinsCatalog" */ "@/components/atmo/EurofinsCatalog.vue"
  );

const Admin = () =>
  import(/* webpackChunkName: "Admin" */ "@/components/atmo/Admin.vue");

const MyProfile = () =>
  import(/* webpackChunkName: "MyProfile" */ "@/components/atmo/MyProfile.vue");

const NotFound = () =>
  import(/* webpackChunkName: "NotFound" */ "@/components/atmo/NotFound.vue");

const fetchAdminInformation = async (to, from, next) => {
  await useAdminInformationsStore().fetchAdminInformation();
  next();
};

export default [
  {
    path: "",
    name: "home",
    redirect: { name: "projects" },
  },
  {
    path: "projects",
    component: Projects,
    children: ProjectsChildren,
  },
  {
    path: "materials",
    component: Materials,
    children: MaterialsChildren,
  },
  {
    path: "eurofins-catalog",
    name: "eurofins-catalog",
    component: EurofinsCatalog,
  },
  {
    path: "admin",
    component: Admin,
    children: AdminChildren,
    beforeEnter: fetchAdminInformation,
  },
  {
    path: "edit-profile",
    name: "edit-profile",
    component: MyProfile,
  },
  {
    path: "not-found",
    name: "not-found",
    component: NotFound,
  },
];
